let curriculum;

export const setCurriculum = ({
  characters,
  sceneProps,
  motivations,
  onboardingTexts,
  levels,
}) => {
  curriculum = {
    assets: {
      characters,
      sceneProps,
      motivations,
      onboardingTexts,
    },
    levels,
  };
};

export const getCurriculum = () => curriculum;
